export const compareCubicleNames = (a: string, b: string) =>
  a.localeCompare(b, undefined, { numeric: true });
